import { useEffect, useState } from 'react';

import { isBrowser } from '@utils/isBrowser';

/* Taken from the wonder Josh W. Comeau,
see https://www.joshwcomeau.com/react/prefers-reduced-motion/ for further details */

const QUERY = '(prefers-reduced-motion: no-preference)';

const getInitialState = () => isBrowser && !window.matchMedia(QUERY).matches;

const usePrefersReducedMotion = () => {
	const [prefersReducedMotion, setPrefersReducedMotion] = useState(getInitialState);
	useEffect(() => {
		if (!isBrowser) {
			return;
		}

		const mediaQueryList = window.matchMedia(QUERY);

		const listener = (event) => {
			setPrefersReducedMotion(!event.matches);
		};

		mediaQueryList.addEventListener('change', listener);

		return () => {
			mediaQueryList.removeEventListener('change', listener);
		};
	}, []);

	return prefersReducedMotion;
};

export default usePrefersReducedMotion;
